module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Blank Page"), _c('small', [_vm._v("It's all start from here "), _c('i', {
    staticClass: "ti-heart"
  }), _c('i', {
    staticClass: "ti-export"
  }), _c('i', {
    staticClass: "ti-printer"
  })])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Blank Page")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Basic")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "ti-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove",
      "data-toggle": "tooltip",
      "title": "Remove"
    }
  }, [_c('i', {
    staticClass: "ti-close"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body",
    staticStyle: {
      "min-height": "400px"
    }
  }, [_c('vl-map', {
    attrs: {
      "load-tiles-while-animating": true,
      "load-tiles-while-interacting": true
    }
  }, [_c('vl-view', {
    attrs: {
      "zoom": 12,
      "center": [110.3712312, -7.8007611],
      "rotation": 0
    }
  }), _vm._v(" "), _c('vl-geoloc', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ctx) {
        return [(ctx.position) ? _c('vl-feature', {
          attrs: {
            "id": "geoloc-feature"
          }
        }, [_c('vl-geom-point', {
          attrs: {
            "coordinates": ctx.position
          }
        })], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('vl-layer-tile', {
    attrs: {
      "id": "osm"
    }
  }, [_c('vl-source-osm')], 1)], 1)], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f1fe4f9a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/OpenLayer.vue
// module id = 1447
// module chunks = 2